/* eslint-disable */
export function encode(s: string) {
  var i = 0;
  var bytes = new Uint8Array(s.length * 4);
  for (var ci = 0; ci != s.length; ci++) {
    var c = s.charCodeAt(ci);
    if (c < 128) {
      bytes[i++] = c;
      continue;
    }
    if (c < 2048) {
      bytes[i++] = (c >> 6) | 192;
    } else {
      if (c > 0xd7ff && c < 0xdc00) {
        if (++ci == s.length) throw 'UTF-8 encode: incomplete surrogate pair';
        var c2 = s.charCodeAt(ci);
        if (c2 < 0xdc00 || c2 > 0xdfff)
          throw (
            'UTF-8 encode: second char code 0x' +
            c2.toString(16) +
            ' at index ' +
            ci +
            ' in surrogate pair out of range'
          );
        c = 0x10000 + ((c & 0x03ff) << 10) + (c2 & 0x03ff);
        bytes[i++] = (c >> 18) | 240;
        bytes[i++] = ((c >> 12) & 63) | 128;
      } else {
        // c <= 0xffff
        bytes[i++] = (c >> 12) | 224;
      }
      bytes[i++] = ((c >> 6) & 63) | 128;
    }
    bytes[i++] = (c & 63) | 128;
  }
  return bytes.subarray(0, i);
}

export function decode(arrayBuffer: ArrayBuffer | ArrayBufferView | string | null) {
  var result = '';
  var i = 0;
  var c = 0;
  var c1 = 0;
  var c2 = 0;
  var c3 = undefined;

  var data = new Uint8Array(
    arrayBuffer as any /* Uint8Array supports a string argument - but types says no */
  );

  // If we have a BOM skip it
  if (data.length >= 3 && data[0] === 0xef && data[1] === 0xbb && data[2] === 0xbf) {
    i = 3;
  }

  while (i < data.length) {
    c = data[i];

    if (c < 128) {
      result += String.fromCharCode(c);
      i++;
    } else if (c > 191 && c < 224) {
      if (i + 1 >= data.length) {
        throw 'UTF-8 Decode failed. Two byte character was truncated.';
      }
      c2 = data[i + 1];
      result += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
      i += 2;
    } else {
      if (i + 2 >= data.length) {
        throw 'UTF-8 Decode failed. Multi byte character was truncated.';
      }
      c2 = data[i + 1];
      c3 = data[i + 2];
      result += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
      i += 3;
    }
  }
  return result;
}
